import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { Modal } from "react-bootstrap";
import SharedForm from "../../../../components/ui/Form";
import styles from './MemberDetailsModal.module.scss';
import CommentList from "../../../../components/ui/CommentList";
import { ALIGN, POSITIONS, VALIDATIONS } from '../../../../constants';

const RetiredMemberDetailsModal = ({ show, onCancel, data }) => {

    const comments = useSelector((state) => state.advisoryGroup?.memberCommentList);

    const [memberComments, setMemberComments] = useState(null);

    const arr = [
        {
            key: 'firstName',
            labelName: 'First Name',
            type: 'text',
            required: false,
        },
        {
            key: 'lastName',
            labelName: 'Last Name',
            type: 'text',
            required: false,
        },
        {
            key: 'startDate',
            labelName: 'Empaneled Date',
            type: 'date',
            required: false,
        },
        {
            key: 'birthday',
            labelName: 'Birthdate',
            type: 'date',
            required: false,
        },
        {
            key: 'healthPlanMemberId',
            labelName: 'Health Plan ID',
            type: 'text',
            required: false,
        },
        {
            key: 'communicationLastDate',
            labelName: 'Last Outreach Date',
            type: 'date',
            required: false,
        },
        {
            key: 'addressLine1',
            labelName: 'Address',
            placeholderName: 'Address',
            type: 'text',
            required: false,
        },
        {
            key: 'phone',
            labelName: 'Phone',
            placeholderName: 'Phone',
            type: 'tel',
            maxLength: 12,
            required: false,
            valid: VALIDATIONS.Number.isPhone,
        },
        {
            key: 'email',
            labelName: 'Email',
            placeholderName: 'Email',
            type: 'email',
            required: false,
        },
    ];

    useEffect(() => {
        if (comments) {
            let commentList = [];
            for (let comment of comments) {
                commentList.push({
                    id: comment.id,
                    firstName: comment.firstName,
                    lastName: comment.lastName,
                    recordCreated: comment.memberCommentCreatedDate,
                    comment: comment.memberComment
                });
            }
            setMemberComments(commentList);
        }
    }, [comments]);

    return (
        <>
            <Modal
                show={show}
                fullscreen={false}
                backdrop="static"
                onHide={onCancel}
                size="md">
                <Modal.Header closeButton>
                    <Modal.Title>Retired Member Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="px-xl-3 py-xl-2">
                        <SharedForm
                            cols={12}
                            array={arr}
                            modelObj={data}
                            viewOnly={true}
                            actionBarPosition={POSITIONS.TOP}
                            actionBarAlign={ALIGN.RIGHT}
                        />
                        <div className="position-relative">
                            <CommentList
                                comments={memberComments}
                                title={
                                    <h3 className={`mb-0 lh-sm ${styles.title}`}>
                                        Comments
                                    </h3>
                                }
                                maxLength={255}
                                customListStyle={`flex-grow-1 ${styles.commentsContainer}`}
                            />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default RetiredMemberDetailsModal;
